<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="headline">Create Outcome</v-card-title>

            <v-card-text>

                <v-text-field
                    label="Outcome Name"
                    v-model="outcome_label"
                    autocomplete="off"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="gray darken-1"
                    text
                    @click="dialog = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    data() {
        return {
            dialog: false,
            outcome_id: null,
            outcome_label: null,
        }
    },

    methods: {
        showDialog(outcome_id)
        {
            this.outcome_id = outcome_id;
            this.outcome_label = null;

            this.$forceUpdate();
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.outcome_id, this.outcome_label);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>